// extracted by mini-css-extract-plugin
module.exports = {"link":"erI8-Vtim8C4qM4uKdZkS"};